import React, { useState } from "react";
import HPageContainer from "../../../hcomponents/HPageContainer";
import HHeader from "../../../hcomponents/HHeader";
import SettingsTabsNavigation from "./SettingsTabsNavigation";
import HPillTabs from "src/hcomponents/HPillTabs";
import HActionButton from "../../../hcomponents/HActionButton";
import { Eye, Copy, AlertTriangle, RefreshCcw, ExternalLink, Plus, ChevronRight, ChevronLeft } from "lucide-react";

const apiKeys = [
  {
    name: "Main Production Key",
    type: "Production",
    color: "bg-blue-600",
    created: "2025-04-15",
    lastUsed: "2025-06-02",
    permissions: ["Read", "Write", "Admin"],
  },
  {
    name: "Integration Test Key",
    type: "Test",
    color: "bg-orange-500",
    created: "2025-05-22",
    lastUsed: null,
    permissions: ["Read", "Write", "Admin"],
  },
];

const ApiSettings = () => {
  const notificationTabs = ["API Keys", "Webhooks"];
  const [tab, setTab] = useState("API Keys");

  return (
    <HPageContainer>
      <HHeader />
      <div className="overflow-auto">
        <SettingsTabsNavigation />

        <h2 className="text-xl font-semibold mx-3 text-gray-800 mb-4">API Settings</h2>

        <HPillTabs
          tabs={notificationTabs}
          activeTab={tab}
          onTabChange={setTab}
          className="mb-6 sm:w-[30%] md:w-[40%] lg:w-[20%]"
        />

        <div className=" bg-white mx-3 mb-3 p-6 overflow-auto h-100% scrollbar-hide rounded-xl border border-gray-200">
          <div className="flex justify-between items-center mb-6 gap-2">
            <div>
              <h1 className="text-lg sm:text-xl md:text-2xl font-semibold text-gray-900">API Keys</h1>
              <p className="text-sm text-gray-600">Manage your API keys for connecting external applications</p>
            </div>
            <HActionButton
              icon={<Plus className="w-4 h-4" />}
              label="Create New Key"
              // onClick={() => history.push('/host/add-invoice')}
              className="w-auto sm:w-auto bg-black text-sm"
            />
          </div>

          <div className="space-y-4">
            {apiKeys.map((key, index) => (
              <div key={index} className="bg-white rounded-xl border border-gray-300">
                <div className="bg-gray-100 rounded-t-xl p-3">
                  <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2">
                    <h2 className="text-base sm:text-sm font-medium text-gray-900 flex items-center gap-2">
                      {key.name}
                      <span
                        className={`text-white text-[10px] sm:text-[11px] font-semibold px-2 py-0.5 rounded-lg ${key.color}`}
                      >
                        {key.type}
                      </span>
                    </h2>

                    <div className="flex items-center gap-2">
                      <RefreshCcw className="w-5 h-5 text-gray-500 hover:text-black cursor-pointer" />
                      <AlertTriangle className="w-5 h-5 text-red-500 cursor-pointer" />
                    </div>
                  </div>
                </div>
                <div className="p-3">
                  <p>API Key</p>
                  <div className="flex justify-between gap-2">
                    <div className="bg-gray-100 rounded-md flex items-center justify-between w-[100%] overflow-hidden">
                      <div className="px-2 sm:px-4 py-2 text-gray-700 tracking-widest text-sm whitespace-nowrap overflow-x-auto scrollbar-hide">
                        •••••••••••••••••••••••••••••••
                      </div>
                      <div className="flex">
                        <button className="w-10 h-10 flex items-center justify-center border border-gray-100 bg-white transition">
                          <Eye className="w-5 h-5 text-gray-600" />
                        </button>
                      </div>
                    </div>
                    <button className="w-10 h-10 flex items-center justify-center bg-white transition border border-gray-300">
                      <Copy className="w-5 h-5 text-gray-600" />
                    </button>
                  </div>

                  <div className="mt-2 text-sm text-gray-500 flex flex-col sm:flex-row sm:items-center sm:gap-4">
                    <span>Created: {key.created}</span>
                    {key.lastUsed && <span>Last used: {key.lastUsed}</span>}
                  </div>

                  <div className="flex gap-2 mt-3">
                    {key.permissions.map(perm => (
                      <span
                        key={perm}
                        className={`px-2.5 sm:px-3 py-1.5 sm:py-2 text-xs sm:text-sm font-semibold rounded-xl border ${
                          perm === "Read"
                            ? "bg-[#4C4AEF] sm:p-3 border-indigo-100 text-white"
                            : perm === "Write"
                              ? "bg-[#4C4AEF] border-indigo-100 text-white"
                              : "text-gray-700 border-gray-200 bg-white"
                        }`}
                      >
                        {perm}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-6 bg-gray-50 border border-gray-200 rounded-lg p-4">
            <div className="flex justify-start items-center mb-1">
              <ChevronLeft size={18} className="text-[#4C4AEF]" />
              <ChevronRight size={18} className="text-[#4C4AEF]" />
              <h3 className="text-sm font-semibold text-gray-900">API Documentation</h3>
            </div>
            <p className="text-sm text-gray-600 mb-3">
              Get detailed information on how to use our API in your applications.
            </p>
            <button className="px-3 sm:px-4 py-1.5 sm:py-2 flex items-center justify-between gap-1 sm:gap-2 border border-gray-300 text-gray-700 rounded-md text-xs sm:text-sm font-medium hover:shadow">
              <ExternalLink size={14} className="sm:w-4 sm:h-4" />
              View Documentation
            </button>
          </div>
        </div>
      </div>
    </HPageContainer>
  );
};

export default ApiSettings;
